import Vue, { PluginFunction } from 'vue'
import debounce from 'lodash.debounce'

// NOTE: tailwind.config.jsと同じにする
const screens = {
  xs: 350,
  sm: 640,
  md: 768,
  lg: 960,
  xl: 1280,
}

const getSize = (val: number) => {
  switch (true) {
    case val < screens.md:
      return 'sm'
    case val >= screens.md && val < screens.lg:
      return 'md'
    case val >= screens.lg && val < screens.xl:
      return 'lg'
    case val >= screens.xl:
      return 'xl'
    default:
      return 'all'
  }
}

export interface Breakpoints {
  width: number
  height: number
  size: ReturnType<typeof getSize>
  sm: boolean
  md: boolean
  lg: boolean
  xl: boolean
}

const getBreakpoints = (
  width: number = window.innerWidth,
  height: number = window.innerHeight
): Breakpoints => {
  const size = getSize(width)
  return {
    width,
    height,
    size,
    sm: size === 'sm' || size === 'md' || size === 'lg' || size === 'xl',
    md: size === 'md' || size === 'lg' || size === 'xl',
    lg: size === 'lg' || size === 'xl',
    xl: size === 'xl',
  }
}

const breakpoints = Vue.observable<Breakpoints>(getBreakpoints())

window.addEventListener(
  'resize',
  debounce(
    () => {
      const { width, height, size, sm, md, lg, xl } = getBreakpoints()
      breakpoints.width = width
      breakpoints.height = height
      breakpoints.size = size
      breakpoints.sm = sm
      breakpoints.md = md
      breakpoints.lg = lg
      breakpoints.xl = xl
    },
    0 // パフォーマンスが問題になりそうだったら増やす
  ),
  false
)

// breakpointを管理するVueプラグイン
const install: PluginFunction<{}> = (Vue) => {
  // $breakpointsプロパティの定義
  Object.defineProperty(Vue.prototype, '$breakpoints', {
    get(): Breakpoints {
      return breakpoints
    },
  })
}

export default {
  install,
}
